import type { GameModule } from '../types';
import Page from './Page';

const lucky7: GameModule = {
  id: 'lucky7',
  displayName: 'Lucky 7',
  tag: 'Casual',
  theme: {
    gradient: 'from-red-600 to-rose-900',
    emoji: '🍀',
    logo: '/games/lucky7/Logo.png',
  },
  orientation: 'portrait',
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-red-900',
    headerTo: 'to-rose-900',
    ring: 'focus:ring-red-500',
    accent: 'bg-red-600',
    accentHover: 'hover:bg-red-500',
    dot: 'bg-red-400',
    softBg: 'bg-red-500/10',
    rangeAccent: 'accent-red-500',
    badgeClasses: 'bg-red-500/20 text-red-300 border-red-500/30',
  },
  Page,
};

export default lucky7;
